import { c as _c } from "react/compiler-runtime";
import { IconDefinition } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '~/lib/utils';
function ActionTrigger(t0) {
  const $ = _c(8);
  const {
    icon,
    className,
    disabled
  } = t0;
  const t1 = disabled && "cursor-not-allowed bg-opacity-80 text-gray-400 hover:bg-white hover:text-gray-400";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cn("flex h-8 w-8 items-center justify-center", className, t1);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== icon) {
    t3 = <FontAwesomeIcon icon={icon} className="h-4 w-4" />;
    $[3] = icon;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
export default ActionTrigger;